import 'url-polyfill'
import Vue from 'vue'
import VueMoment from 'vue-moment'
import * as moment from 'moment'
import 'moment/locale/de'
import App from './App.vue'

Vue.use(VueMoment, { moment })

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#software-form-app')
